// extracted by mini-css-extract-plugin
export var body = "_kn-0";
export var sectionHeader = "_kn-4";
export var shortcutColumns = "_kn-2";
export var shortcutList = "_kn-1";
export var shortcutSection = "_kn-3";